export default[
    {
        path: '/aviso/cadastro',
        name: 'cadastro de aviso', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/aviso/lista',
        name: 'lista do aviso', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/aviso/editar/:id',
        name: 'editar aviso', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]